export default __webpack_public_path__ + "static/media/group2.84661a0a.png";